import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { appHistory } from "app-history";
import { RootState } from "config/reducers";
import { afficheError, afficheMessage } from "modules/notification/service/notification.service";
import { resiliationApi } from "../api/resiliation.api";
import { Resiliation } from "../model/resiliation";
import { TypeStep, resiliationActions } from "../store/resiliation.slice";

export const previousResiliationStep = ():ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch, getState) => {

    const step = getState().resiliation.step;

    const motif = getState().resiliation?.resiliation?.choixResil?.choixResiliation;

    if(step ==0) {
    appHistory.push('/');
}


if (motif === "PROCHAINEECHANCE" && step === TypeStep.recap) {
    dispatch(resiliationActions.specificStep(3));
}

    dispatch(resiliationActions.previousStep());

   
};

    export const firstResiliationStep = ():ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch, getState) => {

        dispatch(resiliationActions.firstStep());
    
    };


    
    export const specificResiliationStep = (specificStep:any):ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch, getState) => {
        const step = getState().resiliation.step;
        if(step == TypeStep.recap && specificStep !== null && specificStep !== undefined ) {
            dispatch(resiliationActions.specificStep(specificStep));
        }
    
    };


    export const majResiliation = (resiliation:Resiliation):ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch, getState) => {

        dispatch(resiliationActions.updateResiliation({resiliation}));
    
        const step = getState().resiliation.step;
        const motif = getState().resiliation?.resiliation?.choixResil?.choixResiliation;

        if (motif === "PROCHAINEECHANCE" && step === TypeStep.ChoixResiliation) {
            dispatch(resiliationActions.resiliationSummary());
        }

        if (step < 4) {
            dispatch(resiliationActions.nextStep());
        } else {
    
            try {
                //save
                dispatch(resiliationActions.progressing(true));
                //appel

                const resiliation = getState().resiliation.resiliation;
               
                const resp = await resiliationApi.postResiliation(resiliation);
    
           
                dispatch(resiliationActions.progressing(false));
                //
                dispatch(afficheMessage("Votre demande a été envoyée"));
                //siok > redirection home
                appHistory.push('/');
    
            } catch (err) {
                dispatch(resiliationActions.progressing(false));
                dispatch(afficheError(err));
            }
    
        }

}

